<template>
  <tbody>
    <tr class="more_bg1">
      <template v-if="eventAllBet.rbinfo">
        <td class="more_left" colspan="5">
          <span id="title_showtype" name="title_showtype" class="more_time">
            <template v-if="eventAllBet.rbinfo.htst != '0'">
              {{ eventAllBet | rb-timer('mm:ss') }}
            </template>
          </span>
          &nbsp;&nbsp;&nbsp;
          <span class="more_yellow_ft">
            <template v-if="eventAllBet.rbinfo.htst == '0'">
              {{ sportTableLang.table['SPORT_TABLE.LBL_HT'] }}
            </template>
            <template v-else-if="validateRBTimer(eventAllBet) == '1'">
              {{ sportAllBetLang['ALL_BET.LBL_1HT'] }}
            </template>
            <template v-else-if="validateRBTimer(eventAllBet) == '2'">
              {{ sportAllBetLang['ALL_BET.LBL_2HT'] }}
            </template>
            <template v-else> - </template>
          </span>
        </td>
      </template>
      <template v-else>
        <td id="title_showtype" name="title_showtype" class="more_live">
          <template v-if="eventAllBet.rb == 1">
            {{ sportAllBetLang['ALL_BET.LBL_LIVE'] }}
          </template>
          <template v-if="eventAllBet.ha == 'N'">
            <img :src="'assets/images/more_n_'+ langSelected +'.jpg'" class="more_n">
          </template>
        </td>
        <td></td>
        <td class="more_date" >
          <span id="title_date" name="title_date" v-if="selectedMarket != 1">{{ eventAllBet.dt | date('DD / M') }}</span>&nbsp;&nbsp;&nbsp;<span id="title_time" name="title_time">{{ eventAllBet.dt | date('HH:mm') }}</span>
        </td>
      </template>
    </tr>
    <tr class="more_bg2">
      <template v-if="eventAllBet.rbinfo">
        <td class="more_red" v-if="eventAllBet.rbinfo.rca > 0 ">
          {{ eventAllBet.rbinfo.rca }}
        </td>
      </template>
      <td class="mo_bg_1">
        <span id="title_team_h" name="title_team_h" v-html="eventAllBet.tacapt"></span>
      </td>
      <template v-if="eventAllBet.rbinfo">
        <td class="mo_bg_2">
          <span id="score_h" class="more_score">{{ eventAllBet.rbinfo.scoa }}</span>&nbsp;
          <span class="more_line">-</span>&nbsp;
          <span id="score_c" class="more_score2">
            {{ eventAllBet.rbinfo.scob }}
            <!-- <span class="more_bold">{{ eventAllBet.rbinfo.scob }}</span> -->
          </span>
        </td>
      </template>
      <template v-else>
        <td class="mo_bg_2">&nbsp;V&nbsp;</td>
      </template>

      <td class="mo_bg_3">
        <span id="title_team_c" name="title_team_c" v-html="eventAllBet.tbcapt"></span>
      </td>
      <template v-if="eventAllBet.rbinfo">
        <td class="more_red" v-if="eventAllBet.rbinfo.rcb > 0 ">
          {{ eventAllBet.rbinfo.rcb }}
        </td>
      </template>
    </tr>
  </tbody>
</template>

<script>
  import DateFilter from '@/vue/filters/date'
  import allBetMixin from '@/vue/mixins/allBet'

  import {
    mapGetters
  } from 'vuex'

  export default {
    mixins: [allBetMixin],
    computed: {
      ...mapGetters([
        'eventAllBet',
        'sportTableLang',
        'sportAllBetLang',
        'selectedMarket'
      ]),
    },
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet-team-info-sc.vue